import { Component, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class FakeDropdown extends ThemeComponent {

    @Ref() target!: HTMLButtonElement;
    @Ref() selectedOption!: HTMLSpanElement;
    @Ref() option!: HTMLButtonElement[];

    private _onChange = new SimpleEvent<string>();

    public get onChange() {
        return this._onChange.asEvent();
    }

    init() {

        // Init target click event listener
        this.$listen(this.target, 'click', () => this.toggleVisibility());

        // Init option click event listener
        if (this.option) {
            for (const option of this.option) {
                this.$listen(option, 'click', () => this.handleOptionSelect(option));
            }
        }

        // Close dropdown if a click occurs elsewhere on the body
        this.$listen(document.body, 'click', (event) => {
            const target = event.target as HTMLElement;
            if (!target?.closest('.fake-dropdown')) {
                this.close();
            }
        });
    }

    toggleVisibility() {
        this.classList.toggle('is-active');
    }

    handleOptionSelect(element: HTMLButtonElement) {

        // Get value selected
        const selectedOptionValue = element.getAttribute('data-value');
        const selectedOptionName = element.textContent;
        if (selectedOptionValue) {

            // Dispatch change
            this._onChange.dispatch(selectedOptionValue);

            // Update target inner HTML
            this.selectedOption.textContent = selectedOptionName;
        }

        // Remove old selected classes
        for (const option of this.option) {
            option.classList.remove('fake-dropdown__option--selected');
        }

        // Add selected class
        element.classList.add('fake-dropdown__option--selected');

        // Toggle visibility
        this.toggleVisibility();
    }

    close() {
        this.classList.remove('is-active');
    }
}
